import React, { FC, useRef } from 'react';
import styles from './index.module.scss';
import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useFeatureFlag, FeatureFlag } from 'src/helpers/featureFlag';
import { Paths } from '../paths';
import { PageHeading, Tag } from 'src/common';
import { faCalendarClock } from '@fortawesome/pro-light-svg-icons';
import { ApiTendersProvider } from 'src/models/procurements/Tenders/providers';
import ExpiringContracts from './SearchResults';
import ExpiringContractsPreview from './Preview';
import { TendersTotal } from 'src/shared';
import { TagType } from 'src/common/Tag';
import { SearchBar } from './SearchBar';

export const ExpiringContractsPage: FC = () => {
  const { t } = useTranslation();
  const isExpiringContractsPageAvailable = useFeatureFlag(FeatureFlag.AnalyticsExpiringContracts);
  const isAnalyticsExpiringContractsLight = useFeatureFlag(FeatureFlag.AnalyticsExpiringContractsLight);

  const tooltipContainerRef = useRef<HTMLDivElement | null>(null);

  return isExpiringContractsPageAvailable || isAnalyticsExpiringContractsLight ? (
    <ApiTendersProvider type={'ExpContract'}>
      <PageHeading
        title={t('Navigation.expiringContracts')}
        desc={t('ExpiringContracts.expiringContractsDesc')}
        icon={faCalendarClock}
        tag={
          isAnalyticsExpiringContractsLight && !isExpiringContractsPageAvailable ? (
            <Tag type={TagType.Light} />
          ) : undefined
        }
      />
      <div className={styles.tooltipContainer} ref={tooltipContainerRef} />
      <div className={styles.content}>
        <SearchBar />
        <TendersTotal className={styles.total} />
        <ExpiringContracts tooltipContainerRef={tooltipContainerRef} />
      </div>
      <ExpiringContractsPreview />
    </ApiTendersProvider>
  ) : (
    <Navigate to={Paths.HOME_PATH} />
  );
};

export default ExpiringContractsPage;
